export const StopnjaDDVEnum = {
  DDV_PROCENTUALNO: 22
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/StopnjaDDVEnum.js